var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:( _obj = {}, _obj[_vm.className] = true, _obj.disabled = _vm.isPending, _obj ),on:{"click":function($event){$event.preventDefault();return _vm.checkIsPending($event)}}},[(_vm.isPending)?_c('span',[_c('i',{staticClass:"fas fa-pulse fa-spinner"})]):_vm._e(),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4612be6","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/spinner-button.vue
// module id = 3RbH
// module chunks = 23